import React from 'react'
import ReactDOM from 'react-dom'
import App from './config/app'
import { BrowserRouter } from 'react-router-dom'
import PropTypes from 'prop-types';
import ReactGA from 'react-ga'

ReactGA.initialize('UA-23939654-1')


class GAListener extends React.Component {
    static contextTypes = {
        router: PropTypes.object
    };

    componentDidMount() {
        this.sendPageView(this.context.router.history.location);
        this.context.router.history.listen(this.sendPageView);
    }

    sendPageView(location) {
        ReactGA.set({ page: '2017' + location.pathname });
        ReactGA.pageview('2017' + location.pathname);
    }

    render() {
        return this.props.children;
    }
}

ReactDOM.render(<BrowserRouter basename={process.env.PUBLIC_URL}><GAListener><App /></GAListener></BrowserRouter>, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js